import { Model } from '@vuex-orm/core'
import { get, last } from 'lodash'

export const TYPE_DIRECTION = 'direction'
export const TYPE_DCS = 'dcs'
export const TYPE_CPO = 'cpo'
export const TYPE_ROOT = 'root'

export default class Organization extends Model {
    static get entity () {
        return 'organizations'
    }

    static fields () {
        return {
            id: this.uid(),
            parentId: this.attr(null).nullable(),
            parent: this.belongsTo(Organization, 'parentId'),
            children: this.hasMany(Organization, 'parentId'),
            text: this.string(''),
            name: this.string(''),
            type: this.string(''),
            a_attr: this.attr(''),
            code: this.attr('99'),
            isActive: this.boolean(true),
        }
    }

    get parentCode() {
        let codes = []

        const f = (org) => {
            let code = get(org, 'code')
            if (code) codes.push(code)
            if (org && org.parent) {
                f(this.$query().with('parent').find(org.parent.id))
            }
        }
        f(this.$query().with('parent').find(this.id))

        return last(codes);
    }

    parentPath(split = ' -> ') {
        let names = []
        const f = (org) => {
            let name = get(org, 'name')
            if (name) names.push(name)
            if (org && org.parent) {
                f(this.$query().with('parent').find(org.parent.id))
            }
        }

        f(this.$query().with('parent').find(this.id))

        return names.reverse().join(split)
    }
}
